/*
  Contador de la cabecera · compatible con el Smart Cart de Rebuy.

  Rebuy escribe el número de artículos en `.cart-count` (su selector configurado,
  que es el de Debutify). Aquí solo se muestra u oculta la burbuja según ese número,
  para que con 0 no aparezca un «0» y con 1 o más aparezca aunque la página se
  cargara con el carrito vacío.

  Dawn, al añadir desde su propio formulario, rehace `#cart-icon-bubble` entero por
  AJAX. Por eso se vigila el contenedor y no el nodo, que puede cambiar.
*/
(function () {
  'use strict';
  var raiz = document.getElementById('cart-icon-bubble');
  if (!raiz) return;

  function ajustar() {
    var burbuja = raiz.querySelector('.cart-count-bubble');
    var num = raiz.querySelector('.cart-count');
    if (!burbuja || !num) return;
    var n = parseInt((num.textContent || '').trim(), 10);
    burbuja.hidden = !(n > 0);
  }

  new MutationObserver(ajustar).observe(raiz, { childList: true, subtree: true, characterData: true });
  ajustar();
})();
